import { z } from 'zod';

export const TelegramAuthRequestSchema = z.object({
  initData: z.string().min(1),
});

export type TelegramAuthRequest = z.infer<typeof TelegramAuthRequestSchema>;

export const AuthIdentityProviderSchema = z.enum(['telegram', 'supabase_email']);
export type AuthIdentityProvider = z.infer<typeof AuthIdentityProviderSchema>;

export const AuthIdentitySummarySchema = z.object({
  provider: AuthIdentityProviderSchema,
  providerSubject: z.string(),
  emailNormalized: z.string().nullable(),
  telegramUserId: z.string().nullable(),
  verifiedAt: z.string().nullable(),
  lastLoginAt: z.string().nullable(),
});
export type AuthIdentitySummary = z.infer<typeof AuthIdentitySummarySchema>;

export const AuthUserSchema = z.object({
  id: z.string(),
  telegramUserId: z.string().nullable(),
  primaryEmail: z.string().nullable(),
  username: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  photoUrl: z.string().nullable(),
  role: z.enum(['user', 'inhound', 'editor', 'admin']),
  createdAt: z.string(),
  lastLoginAt: z.string().nullable(),
  identities: z.array(AuthIdentitySummarySchema),
});
export type AuthUser = z.infer<typeof AuthUserSchema>;

export const AuthResponseSchema = z.object({
  accessToken: z.string(),
  user: AuthUserSchema,
});

export const AdminLoginRequestSchema = z.object({
  login: z.string().min(1),
  password: z.string().min(1),
});

export type AdminLoginRequest = z.infer<typeof AdminLoginRequestSchema>;

export const AdminCredentialIssueResponseSchema = z.object({
  login: z.string(),
  temporaryPassword: z.string(),
  adminUrl: z.string().url(),
});

export type AdminCredentialIssueResponse = z.infer<typeof AdminCredentialIssueResponseSchema>;

export const AuthenticatedUserSchema = z.object({
  user: AuthUserSchema,
});

export type AuthResponse = z.infer<typeof AuthResponseSchema>;
export type AuthenticatedUser = z.infer<typeof AuthenticatedUserSchema>;
